import { defineStore } from "pinia";

export const useProjectsStore = defineStore("projects", {
  state: () => ({
    projects: [],
    articles: [],
    pending: true,
  }),
  actions: {
    async getProjects() {
      try {
        const { data } = await useFetch("/api/projects");
        this.projects = data.value || [];
        this.pending = false;
        console.log(this.projects);
      } catch (error) {
        console.error("Failed to fetch projects:", error);
        this.projects = [];
        this.pending = false;
      }
    },
    async getProjectId(id) {
      try {
        const { data } = await useFetch(`/api/project/${id}`);
        this.projects = data.value || null;
        this.pending = false;
        console.log(this.projects);
      } catch (error) {
        console.error("Failed to fetch projects:", error);
        this.projects = null;
        this.pending = false;
      } finally {
        this.pending = false;
      }
    },

    async getArticles() {
      try {
        const { data } = await useFetch("/api/articles");
        this.articles = data.value || [];
        this.pending = false;
        console.log(this.articles);
      } catch (error) {
        console.error("Failed to fetch articles:", error);
        this.projects = [];
        this.pending = false;
      }
    },
  },
});